import { render, staticRenderFns } from "./SelectMulti.vue?vue&type=template&id=0842f84c&scoped=true&"
import script from "./SelectMulti.vue?vue&type=script&lang=ts&"
export * from "./SelectMulti.vue?vue&type=script&lang=ts&"
import style0 from "./SelectMulti.vue?vue&type=style&index=0&id=0842f84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0842f84c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VChip,VCol,VIcon,VRow,VSelect})
